export const SET_WINDOW = 'REPORT:SET_WINDOW';
export const UPDATE_REPORT_FILTERS = 'REPORT_FILTERS:UPDATE';
export const UPDATE_REPORT_QUERY = 'REPORT_QUERY:UPDATE';
export const UPDATE_REPORT_ACTIVE_QUERY = 'SUBMITTED_REPORT_QUERY:UPDATE';
export const REMOVE_REPORT_QUERY = 'REPORT_QUERY:REMOVE';
export const REMOVE_REPORT_FILTER = 'REPORT_FILTER:REMOVE';
export const UPDATE_CURRENT_REPORT = 'CURRENT_REPORT:UPDATE';
export const LOAD_REPORT = 'REPORT:LOAD';
export const REFRESH_REPORT = 'REPORT:REFRESH';
